import lodash from 'lodash'

import { ErrorType } from 'gql/__generated__/graphql'

import type { IFieldConfig } from './types'
import type { IGraphqlCommonError, IGraphqlError, IGraphqlInputError } from './types'

export const isFieldConfig = (item?: unknown): item is IFieldConfig =>
  lodash.isObject(item) && '__type' in item && item.__type === 'UIField'

export const isInputError = (error: IGraphqlError | null): error is IGraphqlInputError =>
  error?.type === ErrorType.InputError

export const isCommonError = (error: IGraphqlError | null): error is IGraphqlCommonError =>
  error?.type === ErrorType.CommonError
